(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dcu-custom-measurements"] && !Shopify.designMode) return;
  try {
    
  if (!window.dcuMeasurementsInitialized) {
    window.dcuMeasurementsInitialized = true;

    const service = () => document.querySelector('[data-dcu-measurement-service]');
    let pendingProductForm = null;

    document.body.classList.add('dcu-measurements-required');

    const primaryProductForm = () =>
      [...document.querySelectorAll('form[action*="/cart/add"]')].find((form) =>
        form.querySelector('[name="id"]')
      );

    const openFromStickyBar = (event) => {
      const root = service();
      if (!root) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      pendingProductForm = primaryProductForm();
      root.querySelector('[data-dcu-dialog]')?.showModal();
    };

    const wireStickyBar = () => {
      document.querySelectorAll('sticky-add-to-cart .add-to-cart-button').forEach((button) => {
        if (button.dataset.dcuMeasurementGate === 'true') return;
        button.dataset.dcuMeasurementGate = 'true';
        button.addEventListener('click', openFromStickyBar, true);
      });
    };

    wireStickyBar();
    document.addEventListener('shopify:section:load', wireStickyBar);

    document.addEventListener(
      'submit',
      (event) => {
        const root = service();
        if (!root) return;
        const productForm = event.target.closest('form[action*="/cart/add"]');
        if (!productForm) return;
        if (productForm.dataset.dcuMeasurementsReady === 'true') return;

        event.preventDefault();
        event.stopImmediatePropagation();
        pendingProductForm = productForm;
        root.querySelector('[data-dcu-dialog]')?.showModal();
      },
      true
    );

    document.addEventListener('click', (event) => {
      const root = service();
      if (!root) return;
      if (event.target.closest('sticky-add-to-cart .add-to-cart-button')) {
        openFromStickyBar(event);
        return;
      }
      if (event.target.closest('[data-dcu-open-measurements]')) {
        root.querySelector('[data-dcu-dialog]')?.showModal();
      }
      if (event.target.closest('[data-dcu-close]')) {
        root.querySelector('[data-dcu-dialog]')?.close();
      }
    }, true);

    document.addEventListener('submit', (event) => {
      const measurementForm = event.target.closest('[data-dcu-measurement-form]');
      if (!measurementForm) return;
      event.preventDefault();
      if (!measurementForm.reportValidity()) return;

      if (!pendingProductForm) {
        const root = service();
        pendingProductForm = primaryProductForm();
      }
      if (!pendingProductForm) return;

      pendingProductForm.querySelectorAll('[data-dcu-property]').forEach((input) => input.remove());
      const data = new FormData(measurementForm);
      data.forEach((value, key) => {
        if (!value) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        input.dataset.dcuProperty = 'true';
        pendingProductForm.append(input);
      });

      const serviceInput = document.createElement('input');
      serviceInput.type = 'hidden';
      serviceInput.name = 'properties[Custom stitching service]';
      serviceInput.value = 'Measurements submitted with order';
      serviceInput.dataset.dcuProperty = 'true';
      pendingProductForm.append(serviceInput);
      pendingProductForm.dataset.dcuMeasurementsReady = 'true';

      measurementForm.closest('dialog')?.close();
      pendingProductForm.requestSubmit();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dcu-luxury-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dcu-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('[data-dcu-slide]')];
    const dots = [...hero.querySelectorAll('[data-dcu-dot]')];
    if (slides.length < 2) return;
    let active = 0;
    let timer;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === active); dot.setAttribute('aria-current', i === active ? 'true' : 'false'); });
    };
    const start = () => { if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(active + 1), 6500); };
    const reset = () => { window.clearInterval(timer); start(); };
    hero.querySelector('[data-dcu-prev]')?.addEventListener('click', () => { show(active - 1); reset(); });
    hero.querySelector('[data-dcu-next]')?.addEventListener('click', () => { show(active + 1); reset(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); reset(); }));
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dcu-saree-story-slides"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      root.querySelectorAll('[data-dcu-saree-story]').forEach(section => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';
        const track = section.querySelector('[data-story-track]');
        const slides = Array.from(section.querySelectorAll('[data-story-slide]'));
        const dots = Array.from(section.querySelectorAll('[data-story-dot]'));
        const current = section.querySelector('[data-story-current]');
        const toggle = section.querySelector('[data-story-toggle]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let autoplay;
        let isPaused = reduceMotion.matches;
        const go = index => track.scrollTo({ left: ((index + slides.length) % slides.length) * track.clientWidth, behavior: 'smooth' });
        const activeIndex = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        const renderToggle = () => {
          if (!toggle) return;
          toggle.setAttribute('aria-label', isPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
          toggle.querySelector('span').textContent = isPaused ? '▶' : 'Ⅱ';
        };
        const stopAutoplay = () => {
          clearInterval(autoplay);
          autoplay = undefined;
        };
        const startAutoplay = () => {
          stopAutoplay();
          if (isPaused || !window.matchMedia('(max-width: 989px)').matches || document.hidden) return;
          autoplay = setInterval(() => go(activeIndex() + 1), 6000);
        };
        const update = () => {
          const index = Math.min(activeIndex(), slides.length - 1);
          if (current) current.textContent = String(index + 1);
          dots.forEach((dot, dotIndex) => {
            dot.classList.toggle('is-active', dotIndex === index);
            if (dotIndex === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
          });
        };
        const manualGo = index => {
          isPaused = true;
          stopAutoplay();
          renderToggle();
          go(index);
        };
        section.querySelector('[data-story-prev]')?.addEventListener('click', () => manualGo(activeIndex() - 1));
        section.querySelector('[data-story-next]')?.addEventListener('click', () => manualGo(activeIndex() + 1));
        dots.forEach(dot => dot.addEventListener('click', () => manualGo(Number(dot.dataset.storyDot))));
        toggle?.addEventListener('click', () => {
          isPaused = !isPaused;
          renderToggle();
          startAutoplay();
        });
        let frame;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(update);
        }, { passive: true });
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); manualGo(activeIndex() - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); manualGo(activeIndex() + 1); }
        });
        document.addEventListener('visibilitychange', startAutoplay);
        window.addEventListener('resize', startAutoplay, { passive: true });
        reduceMotion.addEventListener('change', event => {
          isPaused = event.matches;
          renderToggle();
          startAutoplay();
        });
        renderToggle();
        update();
        startAutoplay();
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dcu-velum-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dcu-header]').forEach((header) => {
    const dockMenu = header.querySelector('[data-dcu-bottom-menu]');
    const drawer = header.querySelector('.dcu-drawer');
    dockMenu?.addEventListener('click', () => {
      if (drawer) drawer.open = true;
    });
    const announcements = [...header.querySelectorAll('.dcu-mobile-announcement')];
    if (announcements.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let announcementIndex = 0;
      window.setInterval(() => {
        announcements[announcementIndex].classList.remove('is-active');
        announcementIndex = (announcementIndex + 1) % announcements.length;
        announcements[announcementIndex].classList.add('is-active');
      }, 4500);
    }
    const desktopAnnouncements = [...header.querySelectorAll('.dcu-desktop-announcement')];
    if (desktopAnnouncements.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let desktopIndex = 0;
      window.setInterval(() => {
        desktopAnnouncements[desktopIndex].classList.remove('is-active');
        desktopIndex = (desktopIndex + 1) % desktopAnnouncements.length;
        desktopAnnouncements[desktopIndex].classList.add('is-active');
      }, 4500);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
